/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_DieticianInputs */

const en_for_whom_dietician = /** @type {(inputs: For_Whom_DieticianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietician`)
};

const pl_for_whom_dietician = /** @type {(inputs: For_Whom_DieticianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietetyk`)
};

/**
* | output |
* | --- |
* | "Dietician" |
*
* @param {For_Whom_DieticianInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_dietician = /** @type {((inputs?: For_Whom_DieticianInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_DieticianInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_dietician(inputs)
	return en_for_whom_dietician(inputs)
});